import { gql } from '@apollo/client';

export const REMOVE_PROJECT_USER = gql`
    mutation removeProjectUser($id: uuid!) {
        delete_project_users_by_pk(id: $id) {
            id
        }
    }
`;
